import { max, tau } from "./math.js";
function range(i, j) {
    return Array.from({ length: j - i }, function (_, k) { return i + k; });
}
function compareValue(compare) {
    return function (a, b) {
        return compare(a.source.value + a.target.value, b.source.value + b.target.value);
    };
}
export default function () {
    return chord(false, false);
}
export function chordTranspose() {
    return chord(false, true);
}
export function chordDirected() {
    return chord(true, false);
}
function chord(directed, transpose) {
    var padAngle = 0, sortGroups = null, sortSubgroups = null, sortChords = null;
    function chord(matrix) {
        var n = matrix.length, groupSums = new Array(n), groupIndex = range(0, n), chords = new Array(n * n), groups = new Array(n), k = 0, dx;
        matrix = Float64Array.from({ length: n * n }, transpose
            ? function (_, i) { return matrix[i % n][i / n | 0]; }
            : function (_, i) { return matrix[i / n | 0][i % n]; });
        // Compute the scaling factor from value to angle in [0, 2pi].
        for (var i = 0; i < n; ++i) {
            var x = 0;
            for (var j = 0; j < n; ++j)
                x += matrix[i * n + j] + directed * matrix[j * n + i];
            k += groupSums[i] = x;
        }
        k = max(0, tau - padAngle * n) / k;
        dx = k ? padAngle : tau / n;
        // Compute the angles for each group and constituent chord.
        {
            var x = 0;
            if (sortGroups)
                groupIndex.sort(function (a, b) { return sortGroups(groupSums[a], groupSums[b]); });
            var _loop_1 = function (i) {
                var x0 = x;
                if (directed) {
                    var subgroupIndex = range(~n + 1, n).filter(function (j) { return j < 0 ? matrix[~j * n + i] : matrix[i * n + j]; });
                    if (sortSubgroups)
                        subgroupIndex.sort(function (a, b) { return sortSubgroups(a < 0 ? -matrix[~a * n + i] : matrix[i * n + a], b < 0 ? -matrix[~b * n + i] : matrix[i * n + b]); });
                    for (var _i = 0, subgroupIndex_1 = subgroupIndex; _i < subgroupIndex_1.length; _i++) {
                        var j = subgroupIndex_1[_i];
                        if (j < 0) {
                            var chord_1 = chords[~j * n + i] || (chords[~j * n + i] = { source: null, target: null });
                            chord_1.target = { index: i, startAngle: x, endAngle: x += matrix[~j * n + i] * k, value: matrix[~j * n + i] };
                        }
                        else {
                            var chord_2 = chords[i * n + j] || (chords[i * n + j] = { source: null, target: null });
                            chord_2.source = { index: i, startAngle: x, endAngle: x += matrix[i * n + j] * k, value: matrix[i * n + j] };
                        }
                    }
                    groups[i] = { index: i, startAngle: x0, endAngle: x, value: groupSums[i] };
                }
                else {
                    var subgroupIndex = range(0, n).filter(function (j) { return matrix[i * n + j] || matrix[j * n + i]; });
                    if (sortSubgroups)
                        subgroupIndex.sort(function (a, b) { return sortSubgroups(matrix[i * n + a], matrix[i * n + b]); });
                    for (var _a = 0, subgroupIndex_2 = subgroupIndex; _a < subgroupIndex_2.length; _a++) {
                        var j = subgroupIndex_2[_a];
                        var chord_3 = void 0;
                        if (i < j) {
                            chord_3 = chords[i * n + j] || (chords[i * n + j] = { source: null, target: null });
                            chord_3.source = { index: i, startAngle: x, endAngle: x += matrix[i * n + j] * k, value: matrix[i * n + j] };
                        }
                        else {
                            chord_3 = chords[j * n + i] || (chords[j * n + i] = { source: null, target: null });
                            chord_3.target = { index: i, startAngle: x, endAngle: x += matrix[i * n + j] * k, value: matrix[i * n + j] };
                            if (i === j)
                                chord_3.source = chord_3.target;
                        }
                        if (chord_3.source && chord_3.target && chord_3.source.value < chord_3.target.value) {
                            var source = chord_3.source;
                            chord_3.source = chord_3.target;
                            chord_3.target = source;
                        }
                    }
                    groups[i] = { index: i, startAngle: x0, endAngle: x, value: groupSums[i] };
                }
                x += dx;
            };
            for (var _i = 0, groupIndex_1 = groupIndex; _i < groupIndex_1.length; _i++) {
                var i = groupIndex_1[_i];
                _loop_1(i);
            }
        }
        // Remove empty chords.
        chords = Object.values(chords);
        chords.groups = groups;
        return sortChords ? chords.sort(sortChords) : chords;
    }
    chord.padAngle = function (_) {
        return arguments.length ? (padAngle = max(0, _), chord) : padAngle;
    };
    chord.sortGroups = function (_) {
        return arguments.length ? (sortGroups = _, chord) : sortGroups;
    };
    chord.sortSubgroups = function (_) {
        return arguments.length ? (sortSubgroups = _, chord) : sortSubgroups;
    };
    chord.sortChords = function (_) {
        return arguments.length ? (_ == null ? sortChords = null : (sortChords = compareValue(_))._ = _, chord) : sortChords && sortChords._;
    };
    return chord;
}
